import { xlCol, xlColq } from '../../../common/constants'
export const summaryColumnDefs = [
  { header: 'Transactions', field: 'Transaction', textAlign: 'left', xlCol: { dataType: 'string', dataFormatter: null }, hideHeader: true },
  { header: 'Paid', field: 'PaidAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'Paid Manual', field: 'PaidManAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'ToPay', field: 'TopayAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'ToPay Manual', field: 'TopayManAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'ToPay DDDV', field: 'DDDVAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'On Account', field: 'OnAccAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'COD', field: 'CODAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'Self Booking', field: 'SelfAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'FOC', field: 'FOCAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
  { header: 'Total Amount', field: 'TotalAmt', textAlign: 'right', xlCol: { dataType: 'quantity', dataFormatter: null } },
]
export const HeaderColumn = [
  {
    header: 'Branch',
    field: 'Branch',
    xlCol,
  },
  {
    header: 'User',
    field: 'User',
    xlCol,
  },
  {
    header: 'Transaction Type',
    field: 'TransactionType',
    xlCol,
  },
  {
    header: 'Payment Type',
    field: 'PaymentType',
    xlCol,
  },
  {
    header: 'Payment Mode',
    field: 'PaymentMode',
    xlCol,
  },
]
export const TOPAY_AS_COD_HEADER_MAP = {
  TopayAmt: 'COD',
  TopayManAmt: 'COD Manual',
  DDDVAmt: 'COD DDDV',
}
export const TRANSACTION_LABEL_LIST = ['Booking', 'Delivery', 'Refund']
export const TRANSACTION_LABEL_MAP = {
  BKNG: 'Booking',
  DEL: 'Delivery',
  RFND: 'Refund',
}
export const TRANSACTION_LABEL = {
  Booking: 'Booking (A)',
  Delivery: 'Delivery (B)',
  Refund: 'Refund (C)',
}
export const TRANSACTION_CONFIG = {
  [TRANSACTION_LABEL_MAP.BKNG]: {
    freightLabel: 'Freight',
    gstLabel: 'Booking GST',
  },
  [TRANSACTION_LABEL_MAP.DEL]: {
    freightLabel: 'Total LR Amt',
    gstLabel: 'Delivery GST',
  },
  [TRANSACTION_LABEL_MAP.RFND]: {
    freightLabel: 'Freight',
    gstLabel: 'Refund GST',
  },
}
export const getcolumnDefs = (UseFormattedLRinReports, loginCountryId, txnCode) => {
  const config = TRANSACTION_CONFIG[txnCode]
  return [
    {
      headerName: 'S/N',
      field: 'SN',
      xlCol,
      textAlign: 'left',
      hideHeader: true,
      weight: 30,
    },
    {
      headerName: 'LR No',
      field: 'LRNO',
      xlCol,
      textAlign: 'left',
      weight: 90,
    },
    UseFormattedLRinReports === 3 && {
      headerName: 'Formatted LR No',
      field: 'FormattedLRNO',
      xlCol,
      textAlign: 'left',
      weight: 95,
    },
    {
      headerName: `${txnCode} Date`,
      field: 'TransactionDate',
      xlCol,
      textAlign: 'left',
      weight: 85,
    },
    {
      headerName: 'Source',
      field: 'FromCity',
      xlCol,
      textAlign: 'left',
      weight: 85,
    },
    {
      headerName: 'ReferenceID',
      field: 'ReferenceID',
      xlCol,
      textAlign: 'left',
      weight: 80,
    },
    {
      headerName: 'Destination',
      field: 'ToCity',
      xlCol,
      textAlign: 'left',
      weight: 85,
    },
    {
      headerName: 'Payment Type',
      field: 'TYPE',
      xlCol,
      textAlign: 'left',
      weight: 75,
    },
    {
      headerName: 'Consign. Type',
      field: 'ConsignmentType',
      xlCol,
      textAlign: 'left',
      weight: 90,
    },
    {
      headerName: 'User Name',
      field: 'UserName',
      xlCol,
      textAlign: 'left',
      weight: 90,
    },
    {
      headerName: 'Units',
      field: 'Quantity',
      xlCol: xlColq,
      textAlign: 'right',
      weight: 55,
    },
    {
      headerName: config.freightLabel,
      field: 'LRAmount',
      xlCol: xlColq,
      textAlign: 'right',
      weight: 75,
    },
    {
      headerName: 'Other Charges',
      field: 'OtherCharges',
      xlCol: xlColq,
      textAlign: 'right',
      weight: 75,
    },
    loginCountryId !== 2 && {
      headerName: config.gstLabel,
      field: 'GST',
      xlCol: xlColq,
      textAlign: 'right',
      weight: 70,
    },
    {
      headerName: 'Total Amount',
      field: 'TotalAmt',
      xlCol: xlColq,
      textAlign: 'right',
      weight: 80,
    },
  ].filter(Boolean)
}

export const summaryUserWiseColumnDefs = [
  { header: 'User Name', field: 'UserName', xlCol: xlCol, weight: 70  },
  { header: 'Paid', field: 'PaidAmt', xlCol: xlColq, weight: 70  },
  { header: 'Paid Manual', field: 'PaidManAmt', xlCol: xlColq, weight: 70  },
  { header: 'ToPay', field: 'TopayAmt', xlCol: xlColq, weight: 70  },
  { header: 'ToPay Manual', field: 'TopayManAmt', xlCol: xlColq, weight: 70  },
  { header: 'ToPay DDDV', field: 'DDDVAmt', xlCol: xlColq, weight: 70  },
  { header: 'On Account', field: 'OnAccAmt', xlCol: xlColq, weight: 70  },
  { header: 'COD', field: 'CODAmt', xlCol: xlColq, weight: 70  },
  { header: 'Self Booking', field: 'SelfAmt', xlCol: xlColq, weight: 70  },
  { header: 'FOC', field: 'FOCAmt', xlCol: xlColq, weight: 70  },
  { header: 'Total Amount', field: 'TotalAmt', xlCol: xlColq, weight: 70  },
]
